/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Tabs_LibraryInputs */

const id_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pustaka`)
};

const ms_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perpustakaan`)
};

const da_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotek`)
};

const de_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliothek`)
};

const en_us2_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Library`)
};

const es_es2_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca`)
};

const es_mx2_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca`)
};

const fil_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Library`)
};

const fr_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliothèque`)
};

const it_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libreria`)
};

const hu_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Könyvtár`)
};

const nl_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotheek`)
};

const no_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotek`)
};

const pl_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteka`)
};

const pt_br2_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca`)
};

const pt_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca`)
};

const ro_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotecă`)
};

const fi_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjasto`)
};

const sv_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotek`)
};

const vi_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thư viện`)
};

const tr_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kütüphane`)
};

const cs_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knihovna`)
};

const bg_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Библиотека`)
};

const ru_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Библиотека`)
};

const uk_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бібліотека`)
};

const ar_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المكتبة`)
};

const hi_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइब्रेरी`)
};

const th_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คลังเกม`)
};

const ja_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブラリ`)
};

const zh_cn2_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`游戏库`)
};

const zh_hant1_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遊戲庫`)
};

const ko_profile_tabs_library = /** @type {(inputs: Profile_Tabs_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이브러리`)
};

/**
* | output |
* | --- |
* | "Library" |
*
* @param {Profile_Tabs_LibraryInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_tabs_library = /** @type {((inputs?: Profile_Tabs_LibraryInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Tabs_LibraryInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_tabs_library(inputs)
	if (locale === "ms") return ms_profile_tabs_library(inputs)
	if (locale === "da") return da_profile_tabs_library(inputs)
	if (locale === "de") return de_profile_tabs_library(inputs)
	if (locale === "en-US") return en_us2_profile_tabs_library(inputs)
	if (locale === "es-ES") return es_es2_profile_tabs_library(inputs)
	if (locale === "es-MX") return es_mx2_profile_tabs_library(inputs)
	if (locale === "fil") return fil_profile_tabs_library(inputs)
	if (locale === "fr") return fr_profile_tabs_library(inputs)
	if (locale === "it") return it_profile_tabs_library(inputs)
	if (locale === "hu") return hu_profile_tabs_library(inputs)
	if (locale === "nl") return nl_profile_tabs_library(inputs)
	if (locale === "no") return no_profile_tabs_library(inputs)
	if (locale === "pl") return pl_profile_tabs_library(inputs)
	if (locale === "pt-BR") return pt_br2_profile_tabs_library(inputs)
	if (locale === "pt") return pt_profile_tabs_library(inputs)
	if (locale === "ro") return ro_profile_tabs_library(inputs)
	if (locale === "fi") return fi_profile_tabs_library(inputs)
	if (locale === "sv") return sv_profile_tabs_library(inputs)
	if (locale === "vi") return vi_profile_tabs_library(inputs)
	if (locale === "tr") return tr_profile_tabs_library(inputs)
	if (locale === "cs") return cs_profile_tabs_library(inputs)
	if (locale === "bg") return bg_profile_tabs_library(inputs)
	if (locale === "ru") return ru_profile_tabs_library(inputs)
	if (locale === "uk") return uk_profile_tabs_library(inputs)
	if (locale === "ar") return ar_profile_tabs_library(inputs)
	if (locale === "hi") return hi_profile_tabs_library(inputs)
	if (locale === "th") return th_profile_tabs_library(inputs)
	if (locale === "ja") return ja_profile_tabs_library(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_tabs_library(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_tabs_library(inputs)
	return ko_profile_tabs_library(inputs)
});
export { profile_tabs_library as "profile.tabs.library" }